(() => {
  const page = document.querySelector('.sf-page[data-sf-event-date]');
  if (!page) return;

  const progress = page.querySelector('.sf-progress span');
  const updateProgress = () => {
    const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
    const percentage = documentHeight > 0 ? (window.scrollY / documentHeight) * 100 : 0;
    progress.style.width = `${Math.min(100, Math.max(0, percentage))}%`;
  };
  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });

  const eventDate = new Date(page.dataset.sfEventDate).getTime();
  const fields = {
    days: page.querySelector('[data-sf-days]'),
    hours: page.querySelector('[data-sf-hours]'),
    minutes: page.querySelector('[data-sf-minutes]'),
    seconds: page.querySelector('[data-sf-seconds]')
  };
  const countdownTitle = page.querySelector('[data-sf-countdown-title]');

  const renderCountdown = () => {
    const distance = eventDate - Date.now();
    if (distance <= 0) {
      countdownTitle.textContent = 'O Shimano Fest começou!';
      Object.values(fields).forEach((field) => field.textContent = '00');
      return;
    }
    fields.days.textContent = String(Math.floor(distance / 86400000)).padStart(2, '0');
    fields.hours.textContent = String(Math.floor((distance % 86400000) / 3600000)).padStart(2, '0');
    fields.minutes.textContent = String(Math.floor((distance % 3600000) / 60000)).padStart(2, '0');
    fields.seconds.textContent = String(Math.floor((distance % 60000) / 1000)).padStart(2, '0');
  };
  renderCountdown();
  window.setInterval(renderCountdown, 1000);

  const navLinks = [...page.querySelectorAll('.sf-nav a')];
  navLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = page.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  });
  const targets = navLinks.map((link) => page.querySelector(link.getAttribute('href'))).filter(Boolean);

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      navLinks.forEach((link) => {
        link.classList.toggle('is-active', link.getAttribute('href') === `#${visible.target.id}`);
      });
    }, { rootMargin: '-22% 0px -62% 0px', threshold: [0.05, 0.25, 0.5] });
    targets.forEach((target) => observer.observe(target));
  }

  const shareButton = page.querySelector('[data-sf-share]');
  shareButton?.addEventListener('click', async () => {
    const shareData = { title: document.title, text: 'Confira o guia do Shimano Fest 2026', url: window.location.href };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(window.location.href);
        shareButton.textContent = 'Link copiado!';
        window.setTimeout(() => shareButton.textContent = 'Compartilhar', 1800);
      }
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('Não foi possível compartilhar.', error);
    }
  });
})();